import { isApplied } from '../utils/dynamicFilters';

export const filtersQueryBuilder = filters => {
  const query = {};

  const { keywordSearch, statuses } = filters;

  const getValue = i => {
    return !!i.value;
  };

  if (keywordSearch) {
    query.search = keywordSearch;
  }

  if (statuses.filter(isApplied).length > 0) {
    query.active = statuses.filter(isApplied).map(getValue);
  }

  return query;
};

const sortByQueryBuilder = sortBy => {
  if (sortBy) {
    return { sortField: sortBy, sortDirection: 'asc' };
  }

  return {};
};

const paginationQueryBuilder = (
  { perPage, currentPage },
  { keywordSearch }
) => {
  if (keywordSearch) {
    return { perPage };
  }
  return { perPage, page: currentPage };
};

const bookingHostsQueryBuilder = (
  filters = {},
  sortBy = {},
  pagination = {}
) => {
  return {
    ...(Object.keys(filters).length > 0 ? filtersQueryBuilder(filters) : {}),
    ...(Object.keys(sortBy).length > 0 ? sortByQueryBuilder(sortBy) : {}),
    ...(Object.keys(pagination).length > 0
      ? paginationQueryBuilder(pagination, filters)
      : {}),
  };
};

export default bookingHostsQueryBuilder;
